import moment from 'moment'

const DATE_FORMAT = 'ddd, D MMM YYYY, k:mm'

export default function (el, { value }) {
  if (!value) {
    return
  }

  const SELECTED_DATE = value.date || value
  const FORMAT = value.format || DATE_FORMAT

  const TIME = moment.utc(SELECTED_DATE).local()

  let showDate = TIME.fromNow()
  if (TIME.diff(moment(), 'days')) {
    showDate = TIME.format(FORMAT)
  }

  el.innerHTML = showDate
}



// WEBPACK FOOTER //
// ./src/directives/date.js